import React, { useEffect, useReducer } from "react";
import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";

export const Context = React.createContext(null);

const initialFilterData = {
  from: null,
  to: null,
  channelId: '',
  region: '',
  reason: '',
  isLoading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SUBMIT_FILTER':
      return {
        ...state,
        ...action.payload
      }
    case 'EXPORT_DATA':
      return {
        ...state,
        isExporting: true
      }
    case 'EXPORT_DONE':
      return {
        ...state,
        isExporting: false
      }
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: Boolean(action.payload)
      }
    default:
      return {
        ...state
      }
  }
}

export default () => {
  var [state, dispatch] = useReducer(reducer, initialFilterData);

  useEffect(() => {
    document.title = "Hoàn vé"
  }, []);

  return (
    <Context.Provider value={{
      state,
      dispatch
    }}>
      <FilterForm />
      <Table />
    </Context.Provider>
  );
};
